<div class="portal--header">
    <a (click)="navigateBack()" style="cursor:pointer" class="focus-element text-link"><span class="focus--content" tabindex="-1" title="Back">< Back to device interactions</span></a>
    <h1 class="heading">
        {{BulkIdTitle}}
        <ul class="subheading list">
            <li class="list--item">Status:  <span class="h-uppercase h-bold text-color__success">{{deviceStatus}}</span></li>
        </ul>
    </h1>
</div>
<div class="portal--main">
    <form [formGroup]="form" (submit)="submit(form)" autocomplete="off" class="std-form form__search" novalidate>
        <div class="input-addon input-addon__btn-side">
            <label for="search" class="sr-only">Search</label>
            <input type="text" id="search" [formControl]="form.controls['searchTerm']" class="input-addon__btn-side--input" placeholder="Search by consumer name or consumer address">
            <button type="button" (click)="search()" class="std-btn input-addon__btn-side--btn focus-element"><span class="focus--content" tabindex="-1">Search</span></button>
        </div>
    </form>
    <div class="flex-grid space-between bottom stack-sm">
        <div class="flex-grid--item">
            <button id="toggle-button" class="focus-element" collapsible [collapsibleSection]="collapsibleSection" [collapsibleTitle]="collapsibleTitle"><span class="focus--content" tabindex="-1"><span class='accordion-toggle open' #collapsibleTitle style="margin-top: 0;">Filter <svg class="ic-arrow"><use xlink:href="#ic-arrow" href="#ic-arrow"></use></svg></span></span></button>
            <div class="collapsible" #collapsibleSection>
                <div class="btn-group">
                    <ng-container *ngFor="let button of filterList">
                        <button type="button" (click)="filterClick(button)" class="std-btn filter active focus-element" [ngClass]="{'active':button.isClicked}">
                            <span class="focus--content" tabindex="-1">{{button.label}} <span class="detail">{{button.count}}</span></span>
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="flex-grid--item" *ngIf="isScheduled">
            <button class="std-btn danger focus-element" (click)="cancelInteractions()"><span class="focus--content" tabindex="-1">Cancel</span></button>
        </div>
    </div>
    <div class="module-wrapper">
        <div class="module drop-shadow bottom">
            <table *ngIf="!isSearching && interactions.length > 0" class="std-table stacked-sm">
                <thead>
                <th>Status</th>
                <th>Interaction type</th>
                <th>Consumer name</th>
                <th>Supply address</th>
                <th>Requested</th>
                <th>Scheduled</th>
                <th></th></thead>
                <tbody>
                    <tr *ngFor="let item of interactions">
                        <td data-label="Status"><span class="h-uppercase h-bold" [ngClass]="{'text-color__error': (item.requestStatus == 'Error' || item.requestStatus == 'Expired' || item.filterStatus == 'Error'), 'text-color__warning': (item.requestStatus == 'Processing' || item.requestStatus == 'Accepted' || item.requestStatus == 'Initialised'), 'text-color__success': (item.requestStatus == 'Completed')}">{{item.requestStatus == 'Processing' || item.requestStatus == 'Accepted' || item.requestStatus == 'Initialised' ? 'In Progress' : item.filterStatus }}</span></td>
                        <td data-label="Interaction type">{{item.requestName}}</td>
                        <td data-label="Consumer name">{{item.consumerName}}</td>
                        <td data-label="Supply address">{{item.consumerAddress}}</td>
                        <td data-label="Requested">{{item.requestDate | date:'dd/MM/yyyy, H:mm'}}</td>
                        <td data-label="Scheduled">{{  item.scheduleTime ? (item.scheduleTime | date:'dd/MM/yyyy, H:mm') : ''}}</td>
                        <td class="text-right"><a (click)="clickConsumer(item)" class="text-link focus-element"><span class="focus--content" tabindex="-1">View</span></a></td>
                    </tr>
                </tbody>
            </table>
            <app-pagination *ngIf="!isSearching" [page]="page" [pages]="totalPages" (pageChange)="pageSelected($event)"></app-pagination>
        </div>
    </div>
</div>

